import LoginAvatarScreen from './LoginAvatarScreen'
import OAuth from '../components/OAuth'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../styles/images/logo/trx-logo.png'
import defaultLogo from '../styles/images/logo/baruch-logo.svg'

/**
 * Gets user props from App.js
 * Deals with the login avatar and oauth
 * if user is authorized, allow them to use the home button
 * @param props
 * @returns {*}
 * @constructor
 */
const HeaderScreen = (props) => {

var collegeLogoImage = ""

//images located in src/styles/images/logo/
switch (props.collegeLogoName){
  case "baruch":
    collegeLogoImage = require('../styles/images/logo/baruch-logo.svg');
    break;
  case "bentley":
    collegeLogoImage = require('../styles/images/logo/bentley.svg');
    break;
  case "BME":
    collegeLogoImage = require('../styles/images/logo/BME.png');
    break;
  case "hen":
    collegeLogoImage = require('../styles/images/logo/hen.png');
    break;
  case "highpoint":
    collegeLogoImage = require('../styles/images/logo/highpoint-logo.png');
    break;
  case "ntu":
    collegeLogoImage = require('../styles/images/logo/ntu-logo.png');
    break;
  case "nus":
    collegeLogoImage = require('../styles/images/logo/nus-logo.png');
    break;
  case "pitt":
    collegeLogoImage = require('../styles/images/logo/pitt-logo.svg');
    break;
  case "reading":
    collegeLogoImage = require('../styles/images/logo/reading.png');
    break;
  case "rutgers":
    collegeLogoImage = require('../styles/images/logo/rutgers-logo.png');
    break;
  case "udel":
    collegeLogoImage = require('../styles/images/logo/udel-logo.png');
    break;
  case "villanova":
    collegeLogoImage = require('../styles/images/logo/villanova-logo.png');
    break;
}

  console.log('HeaderScreen', props)
  let isDemo = false;
  return (
    <nav className="header">
      <div className='homeButton'>
        <Link to={{pathname: '/Home'}}>
          {!isDemo &&
          <img id="unilogo" src={collegeLogoImage || defaultLogo} />
          }
          {!isDemo &&
          <span className='powerText'>Powered By</span>
          }
          <img src={logo} alt="TraderX"/>
        </Link>
      </div>
      <div className="timeHeader">
        {!!props.time &&
          <h1>{props.time.substring(11,19)}</h1>
        }
      </div>
      <div className="logAv">
        <LoginAvatarScreen user={props.user}/>
      </div>
      <div className="oAuth">
        <OAuth user={props.user} collegeLogoName={props.collegeLogoName}/>
      </div>
    </nav>
  )
}

export default HeaderScreen



// WEBPACK FOOTER //
// ./src/screens/HeaderScreen.js